import ui from "./ui";
import forms from "./forms";
import pages from "./pages";
import fields from "./fields";
import layout from "./layout";
import collaborators from "./collaborators";
import logic from "./logic";
import auth from "./auth";
import selected from "./selected";

import markers from "./markers";
import payment from "./payment";
import configs from "./configs";
import options from "./selectableOptions";
import validations from "./validations";
import settings from "./settings";
import chat from "./chat";
import zapierAuthUrl from "./auth/zapierAuthUrlReducer";
import disconnectIntegrationState from "./auth/disconnectIntegrationReducer";
import hubspotAuthUrlInitialState from "./auth/hubspotAuthUrlReducer";
import hubspotData from "./auth/getHubspotDataReducer";
import hubspotStatus from "./auth/getHubspotStatusReducer";
import updateHubspotProperty from "./auth/updateHubspotPropertyReducer";
import hubspotTables from "./auth/getHubspotTablesReducer";
import initHubspotInitialState from "./auth/initHubspotReducer";

const reducer = {
    ui,
    forms,
    pages,
    fields,
    layout,
    collaborators,
    logic,
    auth,
    selected,
    markers,
    payment,
    configs,
    validations,
    options,
    settings,
    chat,
    zapierAuthUrl,
    disconnectIntegrationState,
    hubspotAuthUrlInitialState,
    hubspotData,
    hubspotStatus,
    updateHubspotProperty,
    hubspotTables,
    initHubspotInitialState,
};

export default reducer;
